import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Eye, Clock, AlertCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-20 md:py-28 bg-heritage-cream bg-paper-texture" data-id="element-122">
      <div className="max-w-5xl mx-auto px-6 content-relative" data-id="element-123">
        <FadeIn data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-125">
            El problema de la{' '}
            <span className="text-heritage-terracotta italic" data-id="element-126">
              "biblioteca invisible"
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-127">
          <div className="space-y-8" data-id="element-128">
            <FadeIn delay={0.1} data-id="element-129">
              <div className="flex gap-4" data-id="element-130">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-heritage-terracotta/10 flex items-center justify-center text-heritage-terracotta" data-id="element-131">
                  <BookOpen className="w-6 h-6" data-id="element-132" />
                </div>
                <div data-id="element-133">
                  <h3 className="font-serif font-semibold text-xl mb-2" data-id="element-134">
                    Cuadernos perdidos
                  </h3>
                  <p className="text-heritage-coffee/80" data-id="element-135">
                    Has intentado anotar cosas en cuadernos que terminan
                    manchados, rotos o simplemente perdidos en el fondo de un
                    cajón.
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-136">
              <div className="flex gap-4" data-id="element-137">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-heritage-terracotta/10 flex items-center justify-center text-heritage-terracotta" data-id="element-138">
                  <Eye className="w-6 h-6" data-id="element-139" />
                </div>
                <div data-id="element-140">
                  <h3 className="font-serif font-semibold text-xl mb-2" data-id="element-141">
                    "Aprenderán mirando"
                  </h3>
                  <p className="text-heritage-coffee/80" data-id="element-142">
                    Confías en que tus hijos aprenderán observándote, pero ellos
                    están más ocupados que nunca y la tecnología parece una
                    barrera.
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-143">
              <div className="flex gap-4" data-id="element-144">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-heritage-terracotta/10 flex items-center justify-center text-heritage-terracotta" data-id="element-145">
                  <AlertCircle className="w-6 h-6" data-id="element-146" />
                </div>
                <div data-id="element-147">
                  <h3 className="font-serif font-semibold text-xl mb-2" data-id="element-148">
                    El misterio de la "pizca"
                  </h3>
                  <p className="text-heritage-coffee/80" data-id="element-149">
                    Tus recetas tienen "un poquito de esto" y "el ojo para
                    aquello". Para ti es instinto, pero para las nuevas
                    generaciones es un misterio imposible de replicar.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} className="bg-heritage-beige p-8 md:p-10 rounded-2xl border border-heritage-gold/20 shadow-sm relative" data-id="element-150">
            <div className="absolute -top-4 -left-4 text-6xl text-heritage-gold/30 font-serif" data-id="element-151">
              "
            </div>
            <p className="text-xl md:text-2xl font-serif leading-relaxed text-heritage-coffee relative z-10" data-id="element-152">
              Sin un método claro, tu biblioteca invisible de sabores está en
              riesgo de{' '}
              <strong className="text-heritage-terracotta" data-id="element-153">
                desaparecer para siempre.
              </strong>
            </p>
            <div className="absolute -bottom-8 -right-4 text-6xl text-heritage-gold/30 font-serif" data-id="element-154">
              "
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}